import React from 'react';
import LoadFoodView from './LoadFoodView';
import SeoMeta from '@/components/seo/SeoMeta';

const Menu: React.FC = () => (
    <>
        <SeoMeta page="menu" />
        <LoadFoodView />
    </>
);

export default Menu;
